import { useEffect } from "react";
import { useIntercom } from "react-use-intercom";
import { useUser } from "../contexts/UserContext";

export default function IntercomIdentity() {
  const { user, isLoading } = useUser();
  const { update } = useIntercom();

  useEffect(() => {
    if (!isLoading && user?.uuid && user?.display_name && user?.email) {
      update({
        userId: user.uuid,
        name: user.display_name.trim(),
        email: user.email,
      });
    }

  }, [user, isLoading, update]);

  return null;
}
